// src/pages/LoginPage.jsx
//
// Same shape as the AFSC reference (username/password form, POST to
// /token/, store the tokens, fetch /user/, redirect) with two real
// changes:
//   - uses the shared apiFetch() from api/client.js instead of raw
//     inline fetch() calls -- AFSC's own LoginPage is the thing
//     api/client.js exists specifically to avoid repeating.
//   - no role-based redirect (admin -> /admin, analyst -> /tasks) since
//     this app doesn't have that page split -- everyone lands on
//     /projects.

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../api/client";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const tokens = await apiFetch("/token/", {
        method: "POST",
        body: JSON.stringify({ username, password }),
      });
      localStorage.setItem("access_token", tokens.access);
      localStorage.setItem("refresh_token", tokens.refresh);

      const user = await apiFetch("/user/");
      localStorage.setItem("username", user.username);
      localStorage.setItem("role", user.role);

      navigate("/projects");
    } catch (err) {
      setError("Login failed. Check your username and password.");
    }
  };

  return (
    <div className="login-page">
      <h2>Log in</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Username</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="btn-primary">
          Log in
        </button>
      </form>
      {error && <p className="form-error">{error}</p>}
    </div>
  );
}
